import { HttpErrorResponse } from '@angular/common/http';

/**
 * Text aus `{ error: "…" }`, so antwortet der `ApiExceptionHandler` bei 400 und 409.
 * Andere Status koennen interne Details tragen und bekommen den Standardtext des Aufrufers.
 */
export function serverMessage(err: unknown): string | null {
  const meant = err instanceof HttpErrorResponse && (err.status === 400 || err.status === 409);
  const body: unknown = meant ? err.error : null;
  const message = body && typeof body === 'object' ? (body as { error?: unknown }).error : null;
  return typeof message === 'string' && message.length > 0 ? message : null;
}

/** 409 mit `code=NAME_TAKEN`: Der Name ist schon vergeben; der Aufrufer zeigt dafuer einen eigenen Text. */
export function isNameTaken(err: unknown): boolean {
  return err instanceof HttpErrorResponse && err.status === 409 && err.error?.code === 'NAME_TAKEN';
}

/** 403 mit `code=PROJECT_ARCHIVED`: Den Grund meldet schon der `projectArchivedInterceptor`. */
export function isProjectArchived(err: unknown): boolean {
  return err instanceof HttpErrorResponse && err.status === 403 && err.error?.code === 'PROJECT_ARCHIVED';
}

export function isStaleVersion(err: unknown): boolean {
  return err instanceof HttpErrorResponse && err.status === 409 && err.error?.code === 'STALE_VERSION';
}

export interface SecretColumnError {
  field: string;
  column: string;
  dataSheetId: string | null;
  testStepId: string | null;
  clientId: string | null;
}

export function secretColumnError(err: unknown): SecretColumnError | null {
  if (!(err instanceof HttpErrorResponse) || err.status !== 400) return null;
  const body = err.error as Record<string, unknown> | null;
  if (body?.['code'] !== 'SECRET_COLUMN_NOT_ENCRYPTED') return null;
  const field = textOrNull(body['field']);
  const column = textOrNull(body['column']);
  if (!field || !column) return null;
  return {
    field,
    column,
    dataSheetId: textOrNull(body['dataSheetId']),
    testStepId: textOrNull(body['testStepId']),
    clientId: textOrNull(body['clientId']),
  };
}

function textOrNull(value: unknown): string | null {
  return typeof value === 'string' && value.length > 0 ? value : null;
}

/**
 * 401 mit `code=SESSION_ENDED`: Ohne Sitzung (Abmeldung in einem anderen Tab) beendet der `msalGateInterceptor`
 * schreibende Anfragen so und meldet es selbst. Das Backend nutzt denselben Code fuer eine beendete Sitzung.
 */
export function isSessionEnded(err: unknown): boolean {
  return err instanceof HttpErrorResponse && err.status === 401 && err.error?.code === 'SESSION_ENDED';
}
